export enum SensorDataSessionActionTypes {
  GET_SENSOR_DATA_SESSIONS = "@@SENSOR_DATA_SESSIONS/GET_SENSOR_DATA_SESSIONS",
  GET_SENSOR_DATA_SESSIONS_SUCCESS = "@@SENSOR_DATA_SESSIONS/GET_SENSOR_DATA_SESSIONS_SUCCESS",
  GET_SENSOR_DATA_SESSIONS_FAILURE = "@@SENSOR_DATA_SESSIONS/GET_SENSOR_DATA_SESSIONS_FAILURE",

  GET_SENSOR_DATA_SESSION = "@@SENSOR_DATA_SESSIONS/GET_SENSOR_DATA_SESSION",
  GET_SENSOR_DATA_SESSION_SUCCESS = "@@SENSOR_DATA_SESSIONS/GET_SENSOR_DATA_SESSION_SUCCESS",
  GET_SENSOR_DATA_SESSION_FAILURE = "@@SENSOR_DATA_SESSIONS/GET_SENSOR_DATA_SESSION_FAILURE",

  DOWNLOAD_SENSOR_DATA_SESSION_VALUES = "@@SENSOR_DATA_SESSIONS/DOWNLOAD_SENSOR_DATA_SESSION_VALUES",
  DOWNLOAD_SENSOR_DATA_SESSION_VALUES_SUCCESS = "@@SENSOR_DATA_SESSIONS/DOWNLOAD_SENSOR_DATA_SESSION_VALUES_SUCCESS",
  DOWNLOAD_SENSOR_DATA_SESSION_VALUES_FAILURE = "@@SENSOR_DATA_SESSIONS/DOWNLOAD_SENSOR_DATA_SESSION_VALUES_FAILURE",

  CREATE_SENSOR_DATA_SESSION = "@@SENSOR_DATA_SESSIONS/CREATE_SENSOR_DATA_SESSION",
  CREATE_SENSOR_DATA_SESSION_SUCCESS = "@@SENSOR_DATA_SESSIONS/CREATE_SENSOR_DATA_SESSION_SUCCESS",
  CREATE_SENSOR_DATA_SESSION_FAILURE = "@@SENSOR_DATA_SESSIONS/CREATE_SENSOR_DATA_SESSION_FAILURE",

  UPDATE_SENSOR_DATA_SESSION = "@@SENSOR_DATA_SESSIONS/UPDATE_SENSOR_DATA_SESSION",
  UPDATE_SENSOR_DATA_SESSION_SUCCESS = "@@SENSOR_DATA_SESSIONS/UPDATE_SENSOR_DATA_SESSION_SUCCESS",
  UPDATE_SENSOR_DATA_SESSION_FAILURE = "@@SENSOR_DATA_SESSIONS/UPDATE_SENSOR_DATA_SESSION_FAILURE",

  DELETE_SENSOR_DATA_SESSION = "@@SENSOR_DATA_SESSIONS/DELETE_SENSOR_DATA_SESSION",
  DELETE_SENSOR_DATA_SESSION_SUCCESS = "@@SENSOR_DATA_SESSIONS/DELETE_SENSOR_DATA_SESSION_SUCCESS",
  DELETE_SENSOR_DATA_SESSION_FAILURE = "@@SENSOR_DATA_SESSIONS/DELETE_SENSOR_DATA_SESSION_FAILURE",

  CLEAR_SENSOR_DATA_SESSIONS = "@@SENSOR_DATA_SESSIONS/CLEAR_SENSOR_DATA_SESSIONS",
  SET_FILTER = "@@SENSOR_DATA_SESSIONS/SET_FILTER",

  SET_FILES_UPLOADING_PERCENTAGE = "@@SENSOR_DATA_SESSIONS/SET_FILES_UPLOADING_PERCENTAGE",

  GET_SENSOR_DATA_SESSION_VALUES = "@@SENSOR_DATA_SESSIONS/GET_SENSOR_DATA_SESSION_VALUES",
  GET_SENSOR_DATA_SESSION_VALUES_SUCCESS = "@@SENSOR_DATA_SESSIONS/GET_SENSOR_DATA_SESSION_VALUES_SUCCESS",
  GET_SENSOR_DATA_SESSION_VALUES_FAILURE = "@@SENSOR_DATA_SESSIONS/GET_SENSOR_DATA_SESSION_VALUES_FAILURE",

  GET_SENSOR_DATA_SESSION_PROCESSED_VALUES = "@@SENSOR_DATA_SESSIONS/GET_SENSOR_DATA_SESSION_PROCESSED_VALUES",
  GET_SENSOR_DATA_SESSION_PROCESSED_VALUES_SUCCESS = "@@SENSOR_DATA_SESSIONS/GET_SENSOR_DATA_SESSION_PROCESSED_VALUES_SUCCESS",
  GET_SENSOR_DATA_SESSION_PROCESSED_VALUES_FAILURE = "@@SENSOR_DATA_SESSIONS/GET_SENSOR_DATA_SESSION_PROCESSED_VALUES_FAILURE",

  SET_CURRENT_SESSION_VALUES_FILTER = "@@SENSOR_DATA_SESSIONS/SET_CURRENT_SESSION_VALUES_FILTER",

  CREATE_SENSOR_DATA_SESSION_MARKER = "@@SENSOR_DATA_SESSIONS/CREATE_SENSOR_DATA_SESSION_MARKER",
  CREATE_SENSOR_DATA_SESSION_MARKER_SUCCESS = "@@SENSOR_DATA_SESSIONS/CREATE_SENSOR_DATA_SESSION_MARKER_SUCCESS",
  CREATE_SENSOR_DATA_SESSION_MARKER_FAILURE = "@@SENSOR_DATA_SESSIONS/CREATE_SENSOR_DATA_SESSION_MARKER_FAILURE",

  DELETE_SENSOR_DATA_SESSION_MARKER = "@@SENSOR_DATA_SESSIONS/DELETE_SENSOR_DATA_SESSION_MARKER",
  DELETE_SENSOR_DATA_SESSION_MARKER_SUCCESS = "@@SENSOR_DATA_SESSIONS/DELETE_SENSOR_DATA_SESSION_MARKER_SUCCESS",
  DELETE_SENSOR_DATA_SESSION_MARKER_FAILURE = "@@SENSOR_DATA_SESSIONS/DELETE_SENSOR_DATA_SESSION_MARKER_FAILURE",

  GET_SENSOR_DATA_SESSION_MARKERS = "@@SENSOR_DATA_SESSIONS/GET_SENSOR_DATA_SESSION_MARKERS",
  GET_SENSOR_DATA_SESSION_MARKERS_SUCCESS = "@@SENSOR_DATA_SESSIONS/GET_SENSOR_DATA_SESSION_MARKERS_SUCCESS",
  GET_SENSOR_DATA_SESSION_MARKERS_FAILURE = "@@SENSOR_DATA_SESSIONS/GET_SENSOR_DATA_SESSION_MARKERS_FAILURE",

  CREATE_SENSOR_DATA_SESSION_MARKER_DOT = "@@SENSOR_DATA_SESSIONS/CREATE_SENSOR_DATA_SESSION_MARKER_DOT",
  CREATE_SENSOR_DATA_SESSION_MARKER_DOT_SUCCESS = "@@SENSOR_DATA_SESSIONS/CREATE_SENSOR_DATA_SESSION_MARKER_DOT_SUCCESS",
  CREATE_SENSOR_DATA_SESSION_MARKER_DOT_FAILURE = "@@SENSOR_DATA_SESSIONS/CREATE_SENSOR_DATA_SESSION_MARKER_DOT_FAILURE",

  DELETE_SENSOR_DATA_SESSION_MARKER_DOT = "@@SENSOR_DATA_SESSIONS/DELETE_SENSOR_DATA_SESSION_MARKER_DOT",
  DELETE_SENSOR_DATA_SESSION_MARKER_DOT_SUCCESS = "@@SENSOR_DATA_SESSIONS/DELETE_SENSOR_DATA_SESSION_MARKER_DOT_SUCCESS",
  DELETE_SENSOR_DATA_SESSION_MARKER_DOT_FAILURE = "@@SENSOR_DATA_SESSIONS/DELETE_SENSOR_DATA_SESSION_MARKER_DOT_FAILURE",

  GET_SENSOR_DATA_SESSION_DOTS = "@@SENSOR_DATA_SESSIONS/GET_SENSOR_DATA_SESSION_DOTS",
  GET_SENSOR_DATA_SESSION_DOTS_SUCCESS = "@@SENSOR_DATA_SESSIONS/GET_SENSOR_DATA_SESSION_DOTS_SUCCESS",
  GET_SENSOR_DATA_SESSION_DOTS_FAILURE = "@@SENSOR_DATA_SESSIONS/GET_SENSOR_DATA_SESSION_DOTS_FAILURE",
}
